<template lang="pug">
  div(
    @click.stop="openSelect()"
  ).e-select-list.select.list {{$translate(selectedTitle)}}
    span(
      v-if="options && options.length > 1"
    ).select-open
    ul(v-if="selectOpened===true")
      li(
        v-for="item in options"
        :key="item.id"
        @click.stop="selectItem(item)"
      ) {{$translate(item.name)}}
</template>

<script>
  import url from '../../utils/url.js'
  import router from '../../routes/index'

  export default {
    name: 'e-select-list',
    props: {
      options: {
        type: Array,
        default: function () {
          return [/* {id:0, name:'test'} */]
        }
      },
      value: String,
      name: {
        type: String,
        default: 'selectList'
      }
    },
    data () {
      return {
        selectOpened: false
      }
    },
    created () {
      // set on create value from url
      if (this.$route.query && this.$route.query[this.name]) {
        // if found set v-model
        let options = this.options
        let foundIndex = options.findIndex(v => v.id == this.$route.query[this.name])
        if (foundIndex > -1) {
          this.$emit('input', this.$route.query[this.name])
        } else {
          this.setFirstAsValue()
        }
      } else {
        this.setFirstAsValue()
      }
      window.addEventListener('click', this.outerClick)
    },
    destroyed () {
      window.removeEventListener('click', this.outerClick)
    },
    computed: {
      selectedTitle () {
        let foundIndex = -1
        let options = this.options
        if (this.value) {
          foundIndex = options.findIndex(v => v.id == this.value)
        }
        if (foundIndex > -1) {
          return options[foundIndex].name
        }
        return ' Выберите значение '
      }
    },
    methods: {
      setFirstAsValue () {
        if (this.options[0]) {
          this.$emit('input', this.options[0].id)
        }
      },
      outerClick () {
        this.closeSelect()
      },
      selectItem (item) {
        this.$emit('input', item.id)
        this.closeSelect()
        // update url state
        let route = url.getRoute(router.history.current)
        route.query[this.name] = item.id
        this.$router.replace(route)
      },
      openSelect () {
        if (this.options && this.options.length > 1) {
          this.selectOpened = true
        }
      },
      closeSelect () {
        this.selectOpened = false
      }
    }
  }
</script>
